import React, { Component } from "react";
import {CLIENT_EDIT_VIEW_ROUTE, SERVICE13_TEXT, SERVICE14_TEXT, SERVICE20_TEXT, SERVICE18_TEXT, SERVICE28_TEXT, SERVICE36_TEXT,SERVICE29_TEXT, SERVICE30_TEXT, SERVICE32_TEXT,
    SERVICE21_TEXT, SERVICE31_TEXT, SERVICE10_TEXT,SERVICE37_TEXT,SERVICE38_TEXT,SERVICE40_TEXT, SERVICE41_TEXT, SERVICE42_TEXT} from "./../helper/Constants";
import Apihelpers from "./../helper/ApiHelper";
import {Alert } from 'rsuite';
import { reactLocalStorage } from 'reactjs-localstorage';
import $ from "jquery";

export default class LoginAsClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientId: this.props.clientId || '',
    }
  }
  
//   componentDidMount() {
//     console.log('call componentDidUpdate..........');
//     if(reactLocalStorage.get('adminLoginObj') !== undefined) {
//         console.log('reload plz this is not clieint page');
//         let login_user_id = reactLocalStorage.get('login_user_id');
//         var url = window.location.href;
//         var arr = url.split("/");
//         url = arr[0] + "//" + arr[2] + "/" + arr[3] + CLIENT_EDIT_VIEW_ROUTE + "/" + login_user_id;
//         //console.log('url',url);
//         window.location.href = url;
//     }
//   }

  loginClientFun = () => {
    $('.loader').show();

    let adminLoginObj = {
        expires_at: reactLocalStorage.get("expires_at"),
        user_name: reactLocalStorage.get("user_name"),
        login_type: reactLocalStorage.get("login_type"),
        internalToken: reactLocalStorage.get("internalToken"),
        authToken: reactLocalStorage.get("authToken")
    }
    console.log('adminLoginObj',adminLoginObj);
    
    Apihelpers.postdataresponse('users/profilelending', {userId: this.state.clientId}).then(res => {
        if (res.data.status === true) {
          reactLocalStorage.clear();
          reactLocalStorage.set('adminLoginObj', JSON.stringify(adminLoginObj));

          reactLocalStorage.set('authToken', res.data.token);
          reactLocalStorage.set("expires_at", res.data.expire_datetime_timestamp); 
          reactLocalStorage.set("login_type", res.data.user_type);
          reactLocalStorage.set("user_name", res.data.name);

            reactLocalStorage.set("login_user_id", res.data.data._id);
            let plans = JSON.parse(res.data.data.active_plan).service;
            console.log('plans',plans);
            plans.forEach((obj)=>{
                if (obj.plantype === SERVICE13_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_primePDF_service", obj.plantype);
                } else if (obj.plantype === SERVICE14_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api-history_service", obj.plantype);
                } else if (obj.plantype === SERVICE20_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_variant_mapping_service", obj.plantype);
                } else if (obj.plantype === SERVICE18_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_challanpdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE28_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_panFetchpdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE36_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_aadhaarFetchpdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE29_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_panExtensivepdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE30_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_aadhaarExtractionpdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE31_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_basicForgerypdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE32_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_api_advanceForgerypdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE21_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_rcPrimeReversePdf_service", obj.plantype);
                } else if (obj.plantype === SERVICE10_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_rcExcel_service", obj.plantype);
                } else if (obj.plantype === SERVICE37_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_challanExcel_service", obj.plantype);
                } else if (obj.plantype === SERVICE38_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_mobile_rc_excel_service", obj.plantype);
                } else if (obj.plantype === SERVICE40_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_raw_report_service", obj.plantype);
                } else if (obj.plantype === SERVICE41_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_buheadbilling_service", obj.plantype);
                } else if (obj.plantype === SERVICE42_TEXT && obj.isActive === 1) {
                    reactLocalStorage.set("is_have_dashboard_service", obj.plantype);
                } 

            })

            let internalToken = res.data.data.token;
            reactLocalStorage.set("internalToken", internalToken);

          // console.log(res.data.data[0].user_type);
          var url = window.location.href;
          var arr = url.split("/");
          url = arr[0] + "//" + arr[2] + "/" + arr[3] + CLIENT_EDIT_VIEW_ROUTE + "/" + res.data.data._id;
          //console.log('url',url);
          //window.location.href = url;
          //window.location.replace(url);
          window.open(url, '_blank');
          setTimeout(()=>{
            window.close();
          },100);
        } else {
          $('.loader').hide();
        }
      });
  }

  render(){
    return(
      <button title="Login as client" className="btnLink" onClick={this.loginClientFun}><i className="fa fa-sign-in"></i></button>
    )
  }
}

